import { StaticNavigationNavigationItemDtoType } from '@ori/static-api-client-react';
import type { StaticApplicationsFooterBffFooterDto } from '@ori/static-api-client-react';

export const extractFooterNavigationType = (data?: StaticApplicationsFooterBffFooterDto) =>
  data?.application?.navigations.find((x) => x.navigationType === StaticNavigationNavigationItemDtoType.Footer);
